// extracted by mini-css-extract-plugin
export default {"errorContent":"ErrorInfo_errorContent__JaXtA","error":"ErrorInfo_error__D6KuX","errorText":"ErrorInfo_errorText__+6STX","errorImageWrapper":"ErrorInfo_errorImageWrapper__p4sZX"};